<div class="container">

	<!-- <div class="page-header">
	</div> -->

	<div>
		<h3>Festaria</h3>

		<!-- <ul class="nav nav-tabs" role="tablist">
		  <li role="presentation" [ngClass]="this.loginType == 'manager' ? 'active' : ''" (click)="changeLoginType('manager')"><a href="javascript:;">管理者</a></li>
		  <li role="presentation" [ngClass]="this.loginType == 'store' ? 'active' : ''" (click)="changeLoginType('store')"><a href="javascript:;">スタッフ</a></li>
		</ul> -->
	</div>
	<br>
	<form method="post" [formGroup]="form" (ngSubmit)="submit()" class="form-inline ">

		<!-- <div class="control-group ">
			<label for="email">Email</label>
			<div class="controls">
				<input type="email" name="email" value="" class="form-control">
				
			</div>
		</div> -->
		<!-- <div class="control-group ">
			<label for="user_code">社員コード</label>
			<div class="controls">
				<input type="text" name="user_code" value="" class="form-control">
				
			</div>
		</div> -->



		<div class="control-group">
			<label for="store_id">部門コード</label>
			<div class="controls">
				<input type="text" name="store_id" (change)="loginInfoChange()" formControlName="store_id" class="form-control">
			</div>
		</div>

		<div class="control-group">
			<label for="user_id">担当者コード</label>
			<div class="controls">
				<input type="text" name="user_id" (change)="loginInfoChange()" formControlName="user_id" class="form-control">
			</div>
		</div>

		<div class="control-group ">
			<label for="password">パスワード</label>
			<div class="controls">
				<input type="password" name="password" (change)="loginInfoChange()" formControlName="password" class="form-control">
			</div>
		</div>
		<br>
		<div class="error-msg alert alert-danger" *ngIf="this.isError">
			<span>{{this.errorMsg}}</span>
		</div>
		<button type="submit" [disabled]="!form.valid" name="button" class="btn btn-default">ログイン</button>
		<br><br>
		<p>※ 本人以外の｢社員コード｣「パスワード」を使用したログインは<span style="border-bottom: 1px solid black;">禁止</span>です。<br>

			・パスワードをお忘れの場合は、管理者までお問い合わせください。<br>
			
			・5回連続のパスワード入力間違いで、アカウントにロックがかかります。<br>
			
			  ロック解除の依頼は、管理者までご依頼ください。</p>
		<!-- <a href="/auth/signup" class="btn btn-default">Sign up</a> -->
	</form>

</div>